export const PREVIEW_TITLE = 'DRIVE request preview';

export const MAPPING_DISABLED_MESSAGE =
  "This company sends DRIVE's built-in participant set; turn on contact-type mapping to send these parties.";

export const NO_PARTICIPANTS_MESSAGE = 'This DRIVE request would carry no participants';

export const PreviewIssueKind = {
  UNMAPPED: 'unmapped',
  OVERFLOW: 'overflow',
  WARNING: 'warning',
};

export const PreviewParticipantColumnId = {
  PARTICIPANT_TYPE: 'participantType',
  NAME: 'name',
  CONTACT_TYPE: 'contactTypeName',
  EMAIL: 'email',
};

export const PREVIEW_PARTICIPANT_COLUMN_LABELS = {
  [PreviewParticipantColumnId.PARTICIPANT_TYPE]: 'DRIVE type',
  [PreviewParticipantColumnId.NAME]: 'Name',
  [PreviewParticipantColumnId.CONTACT_TYPE]: 'Contact type',
  [PreviewParticipantColumnId.EMAIL]: 'Email',
};

export const UNKNOWN_CONTACT_TYPE = 'Unknown';

export const OVERFLOW_UNKNOWN_SLOTS_MESSAGE = "Exceeds DRIVE's slots for this type";
